module.exports = __webpack_public_path__ + "static/img/Waterforce.0a2765b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/thumbnails/Waterforce.jpg
// module id = HfC+
// module chunks = 0